import ball from './ball.vue'

function plugins(Vue) {
  Vue.component("ball", ball);
}

export default plugins;